export default {
    state: {
        hasVFairs: false,
        hackEnabled: false,
        articles: [],
        hasArticles: false,
        pavilionId: null,
        vFairUser: undefined,
    },
    getters: {
        getHasVFairs: state => () => state.hasVFairs,
        getHackEnabled: state => () => state.hackEnabled,
        getArticles: state => () => state.articles,
        getHasArticles: state => () => state.hasArticles,
        getPavilionId: state => () => state.pavilionId,
        getVFairUser: state => () => state.vFairUser,
    },
    mutations: {
        setHasVFairs: (state, bool) => {
            state.hasVFairs = bool;
        },
        setHackEnabled: (state, enabled) => {
            state.hackEnabled = enabled;
        },
        setArticles: (state, articles) => {
            state.articles = articles;
            state.hasArticles = articles ? true : false;
        },
        setPavilionId: (state, pavilionId) => {
            state.pavilionId = !!pavilionId ? pavilionId : null;
        },
        setVFairUser: (state, vFairUser) => {
            state.vFairUser = vFairUser;
        },
    },
};
